module.exports = __webpack_public_path__ + "img/arrow_rightDouble_gray.7517b394.svg";